// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Vavgy","title":"Header_title__32CNq","left":"Header_left__KLFxK","clinicName":"Header_clinicName__3lODP"};